import React from "react";

import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import Validate from "js/utilities/validate";
import Api from "js/utilities/fnapi-client";
import * as config from "../../config";
import UserHandler from "js/utilities/user-handler";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"

import TextRow from "../elements/text-row.jsx";
import TextAreaRow from "../elements/text-area-row.jsx";
import serialize from "form-serialize";

export default React.createClass({

  mixins: [Navigation],

  displayName: "General Questions",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      loggedInEmail: "",
      error: "",
      success: "",
      loading: false,
      complete: false,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    sidebarOnClicks()
    mountCode(this);
  },

  componentWillMount() {
    if (UserHandler.loggedIn() && UserHandler.getUser().email) {
      this.setState({loggedInEmail: UserHandler.getUser().email})
    }
    window.addEventListener('popstate', this.urlChanged, false)
  },


  urlChanged() {
    urlChangeHandler();
  },


  updateField: function(event){
    let stateObject = function() {
        let returnObj = {};
        returnObj[this.target.id] = this.target.value;
        return returnObj;
    }.bind(event)();
    this.setState( stateObject );
  },

  render: function() {
      return (
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="user" />
                  <h2 id="general-questions">General Questions</h2>
                </div>
                <p>Use the form below to send us a general question.</p>
                <hr />
              </section>

              <section>
                <blockquote><p><strong>Important:</strong> For bugs, issues, crashes, errors, etc., please see the <Link to="/support">Support Page</Link>.  Issues and bugs submitted through this form will be immediately closed.</p></blockquote>
                <br/>
              </section>
              <section className="form-section general-question-form">
                <form autoComplete="off" onSubmit={this.handleSubmit} className="form-element" id="general-question-form" >
                  <TextRow field="name" label="Name" placeholder="Please provide Your Name" requiredField="1" onKeyUp={this.updateField} />
                  <TextRow field="email" label="Email" placeholder="Please provide Your Email" requiredField="1" defaultValue={this.state.loggedInEmail} onKeyUp={this.updateField} />
                  <TextRow field="phone" label="Phone Number" placeholder="Please provide Your Phone Number" requiredField="1" onKeyUp={this.updateField} />
                  <TextAreaRow field="question" label='Briefly describe your Question' rows="4" requiredField="1" placeholder="Be as specific and brief as you can" onChange={this.updateField}/>

                  <div className="btn-new-container">
                    <button type="submit" className="btn btn-new submit-btn" disabled={this.state.loading ? "disabled" : ""}>
                      {!this.state.loading ? <span>Submit</span> : <span>Processing...</span> }
                    </button>
                  </div>
                </form>
                <br/>
                {this.state.error != "" ? <p className="error-message">{this.state.error}</p> : "" }
                {this.state.success != "" ? <p className="success">{this.state.success}</p> : "" }
              </section>
              <SDKSidebar menuType="main" title="General Question"/>
            </div>
          </div>
        </div>
        );
      },

      getAllFormValues: function(){
          let form = document.querySelector("#general-question-form");
          return serialize(form, {hash: true});
      },


      handleSubmit: function(event) {
        event.preventDefault();

        let data = this.getAllFormValues();

        this.setState({error: "", success: "", loading: true});
        let errorMessage = "";
        if (!Validate.email(data.email)) {
          errorMessage = "Please enter a valid email address";
        }


        if(errorMessage != "") {
          this.setState({error: errorMessage, loading: false, success:""});
          return;
        }
        else {
          this.setState({error: "", success: "", loading: true});

          Api.post("contact/general-question-email",data).then((response) => {
              document.getElementById("general-question-form").reset();
              this.setState({error: "", success: "Thank you for your request, we will contact you as soon as possible with more information.", loading: false});
          }).catch( (error) => {
              this.setState({error: error.message, success: "", loading: false});
          });
        }
      },
    });



// WEBPACK FOOTER //
// ./src/js/components/screens/general-questions.jsx